import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from '@mui/material';
import { useSnackbar } from 'notistack';

const Logout = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleConfirmLogout = async () => {
    setIsLoggingOut(true);
    try {
      await signOut(auth);
      enqueueSnackbar('Logged out successfully', { variant: 'success' });
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
      enqueueSnackbar('Logout failed', { variant: 'error' });
      navigate('/portal/home');
    }
  };

  const handleCancel = () => {
    navigate(-1); 
  };

  return (
    <>
      {isLoggingOut ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
        >
          <CircularProgress />
          <Typography variant="h6" mt={2}>
            Logging out...
          </Typography>
        </Box>
      ) : (
        <Dialog
          open={true}
          onClose={handleCancel}
          aria-labelledby="confirm-logout-title"
          aria-describedby="confirm-logout-description"
        >
          <DialogTitle id="confirm-logout-title">Confirm Logout</DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-logout-description">
              Are you sure you want to log out?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="primary" sx={{
        
         textTransform:"none"
        
      }}>
              Cancel
            </Button>
            <Button onClick={handleConfirmLogout} color="error" autoFocus  sx={{
        color:"primary",
        textTransform:"none"
       
     }}>
              Logout
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default Logout;
